import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StoreMstApi } from '../api/storemst.api';
import { switchMap, map } from 'rxjs/operators';

import { StoreMst,StoreMstData } from '../../../interfaces/masters/storemst';

@Injectable()
export class StoreMstService extends StoreMstData  {

  constructor(private api: StoreMstApi) {
    super();
  } 
  list(url: string): Observable<StoreMst[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<StoreMst>{
      return this.api.getById(url);
  }
  
  create(url: string, data:StoreMst): Observable<StoreMst[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:StoreMst): Observable<StoreMst> {
    return this.api.update(url,data);
  } 
  
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
